import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
import Button from '../../common/Button';
import { useHistory } from 'react-router-dom';

function Breadcrumb({
    navigation,
    iconClass,
    className,
    isChallengeBanner,
    id,
}) {
    const history = useHistory();
    const firstPage = navigation[0];
    const listItems =
        navigation &&
        navigation.map((page, index) => {
            if (index != 0) {
                return index != navigation.length - 1 ? (
                    <li
                        key={`breadcrumb-${index}`}
                        className="breadcrumb-item "
                    >
                        <a href={page.path}>{page.title}</a>
                    </li>
                ) : (
                    <li
                        key={`breadcrumb-${index}`}
                        className="breadcrumb-item active"
                    >
                        <span>{page.title}</span>
                    </li>
                );
            }
        });

    return (
        <ol className={`breadcrumb ${className}`}>
            <li key={`breadcrumb-0`} className="breadcrumb-item">
                <i className={iconClass}></i>
                <a href={firstPage.path}>{firstPage.title}</a>
            </li>
            {listItems}
            {isChallengeBanner && (
                <li>
                    <Button
                        variant="main challenge-edit-breadcrumbs"
                        value="Edit challenge"
                        onClick={() => history.push(`/challenges/${id}/edit`)}
                    />
                </li>
            )}
        </ol>
    );
}

Breadcrumb.propTypes = {
    // navigation to render
    navigation: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            path: PropTypes.string,
        }),
    ),
    // icon to display for parent page
    iconClass: PropTypes.string,
    className: PropTypes.string,
    id: PropTypes.string,
    isChallengeBanner: PropTypes.bool,
};

Breadcrumb.defaultProps = {
    navigation: [],
    iconClass: '',
    id: '',
    className: '',
    isChallengeBanner: false,
};

export default Breadcrumb;
